var s = (p, e, o) => new Promise((a, r) => {
  var c = (t) => {
    try {
      i(o.next(t));
    } catch (n) {
      r(n);
    }
  }, g = (t) => {
    try {
      i(o.throw(t));
    } catch (n) {
      r(n);
    }
  }, i = (t) => t.done ? a(t.value) : Promise.resolve(t.value).then(c, g);
  i((o = o.apply(p, e)).next());
});
import { selfAxios as l } from "@oppein/op-utils";
function m(p) {
  return s(this, null, function* () {
    const {
      data: e
    } = yield l.post(
      "/production-order/engineering/bpmSpecialFlow/getDjjApplyPageList",
      p
    );
    return e == null ? void 0 : e.data;
  });
}
export {
  m as postGetDjjApplyPageList
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/bpmSpecialFlow/getDjjApplyPageList/post.js
// module id = 1794
// module chunks = 67